// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb__G0uyW","breadcrumb-item":"breadcrumb-item__1daB3"};